import { ReactNode } from "react";
import styled from "styled-components/native";

const StyledWideMain = styled.View`
	display: flex;
	padding: 25vh 14.1% 3.5rem 14.1%;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	flex: 1 0 0;
	align-self: stretch;
`;

interface Props {
	children: ReactNode;
}

const WideCreateAccountWrapper: React.FC<Props> = ({ children }) => {
	return (
		// @ts-ignores
		<StyledWideMain>{children}</StyledWideMain>
	);
};

export default WideCreateAccountWrapper;
